import { defineMessages } from 'react-intl'

const scope = 'app.containers.Business'

export default defineMessages({
  documented: {
    id: `${scope}.documented`,
    defaultMessage: 'Documented Business Activity',
  },
  employees: {
    id: `${scope}.employees`,
    defaultMessage: 'Employees',
  },
  locations: {
    id: `${scope}.locations`,
    defaultMessage: 'Locations',
  },
  contact: {
    id: `${scope}.contact`,
    defaultMessage: 'Contact Information',
  },
})
